export enum KPI_TYPE_ID {
    NORMAL_KPI = 1,
    BUSINESS_MIX_ACCOUNT = 2,
    BUSINESS_MIX_PRODUCT = 3
    }
    